import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Select from 'react-select';

class CapacitySubTypeSelector extends Component {
  render() {
    const { t, onChange, placeholder, value } = this.props;
    const options = [
      { value: 'load', label: t('capacitySubType.load') },
      { value: 'vehicle', label: t('capacitySubType.vehicle') },
    ];
    return (
      <Select
        value={options.find((option) => option.value === value)}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={() => t('noOptions')}
      />
    );
  }
}

export default withTranslation('translation')(CapacitySubTypeSelector);
